import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

export class PostCloseEntryUseCase {
  constructor(private reviewEntryRepository: ReviewEntryRepository) {}

  async postCloseEntry(entryId: string): Promise<void> {
    try {
      await this.reviewEntryRepository.postCloseEntry(entryId)
    } catch (error) {
      console.error(`Error in PostCloseEntryUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
